import { Button, Flex } from '@chakra-ui/react';
import React from 'react';
import { Link, Navigate } from 'react-router-dom';

import { ImplementationsTable } from './ImplementationsTable';
import { Icon } from 'packages/common-frontend/components/icons';
import { Typography } from 'packages/common-frontend/components/Typography';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Fragments
const RouteBase = () => (
  <>
    <Flex justify="space-between">
      <Typography variant="page-title">Implementations</Typography>
      <Button
        as={Link}
        to="/settings/implementations/create"
        variant="secondary"
        leftIcon={<Icon icon="plus" />}
      >
        New Implementation
      </Button>
    </Flex>
    <ImplementationsTable />
  </>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
